import { NgModule } from '@angular/core';

import { GuidaAllertaRoutingModule } from './guida-allerta-routing.module';
import { CommonModule } from '@angular/common';
import { GuidaAllertaComponent } from './guida-allerta.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { CustomHeaderComponent } from './custom-header/custom-header.component';

@NgModule({
  imports: [
    CommonModule,
    GuidaAllertaRoutingModule,
    NgbTooltipModule,
    AgGridModule,
  ],
  declarations: [GuidaAllertaComponent, CustomHeaderComponent],
  exports:[GuidaAllertaComponent]
})
export class GuidaAllertaModule { }
